module.exports = __webpack_public_path__ + "assets/img/acbf-mc.svg";